module.exports = __webpack_public_path__ + "static/media/ke.3001c22e.svg";